<template>
  <teleport :disabled="!appendToBody" to="body">
    <div 
      v-if="show" 
      :class="['success-loading', animationStyle && animationStyle.value === 1 ? 'success-loading2' : 'success-loading1', isInstrument ? 'instr' : ''] " 
    >
      <div v-if="animationStyle && animationStyle.value === 1" class="loading-box2" :style="{ width: height > 300 ? '180px' : '140px', height: height > 300 ? '180px' : '140px' }">
        <el-image :style="{width: height > 300 ? '140px' : '120px'}" :src="loadingUrl"/>
        <span class="loading-tip" :style="{fontSize: '16px'}">{{ loadingText }}</span>
      </div>
      <div v-else class="loading-box1" 
          :style="{width: '200px' , height: '200px'}">
        <el-image :style="{width: '140px'}" :src="loadingUrl"/>
        <span class="loading-tip" :style="{fontSize: '16px'}">{{ loadingText }}</span>
      </div>
    </div>
  </teleport>
</template>

<script>
export default {
  name: 'successLoading',
  data() {
    return{
      height: 800
    }
  },
  props:{
    show: {
      type: Boolean,
      default: false
    },
    animationStyle: {},
    isInstrument: Boolean,
    appendToBody: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    loadingUrl () {
      const url = `https://bigdata.topeti.com/PCRepository/mainPlatform/successLoading${this.animationStyle && this.animationStyle.value == 1 ? 2 : 1}.gif` 
      return url
    },
    loadingText () {
      let text = '提交完成'
      if (this.animationStyle) {
        text = this.animationStyle.animationList[this.animationStyle.value].text
      }
      return text
    }
  },
  watch: {
    show: {
      handler(val) {
        if (val) {
          this.$nextTick(() => {
            const EL = document.querySelector('.success-loading')
            if (EL) {
              this.height = EL.offsetHeight
            }
          })
        }
      },
    }
  }
}
</script>

<style lang="scss" scoped>
  .success-loading1 {
    background-color: rgba(0, 0, 0, .3);
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
  }
  .success-loading2 {
    background-color: #FFFFFF;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
  }
  .instr {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  }
  .success-loading {
    z-index: 9999;
    left: 0;
    
    .loading-box1, .loading-box2  {
      margin: 0 auto;
      top: 50%;
      position: relative;
      transform: translateY(-50%);
      padding: 10px 10px 30px 10px;
      display: flex;
      flex-direction: column;
      align-items: center;
      border-radius: 18px;
      text-align: center;
      background-color: #fff;
      .loading-tip {
        margin-top: 4px;
        color: #333333;
      }
    }
    .loading-box1 {
      padding: 10px;
    }
  }
</style>